let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6V23Z")).then(() => parcelRequire('iWMY9'));